define(['jquery', 'jquery.transit', 'modernizr', 'container'], function ($, transit, modernizr, container) {

    var router = function () {

        var publicVars = {
        };

        var privateVars = {
            name: 'router',

            disabled: false,

            trackedUrls: new Map()
        };


        var privateMethods = {
            prepareObj: function (options) {
                publicVars = $.extend(true, publicVars, options);

                privateMethods.startup();
                privateMethods.bind();
            },
            startup: function () {

            },
            bind: function () {
                container.msg(privateVars.name + ' - module started');
            },

            route: function(url, metaTitle, options) {

                if(!privateVars.disabled) {
                    container.msg(privateVars.name + ' route to: ' + url);

                    if (window.history.replaceState) {
                        window.history.replaceState({}, "", url);
                    }

                    if(metaTitle) {
                        document.title = metaTitle;
                    }

                    //if((!options || !options.disableTrack) && !privateVars.trackedUrls.has(url)) {

                    if((!options || !options.disableTrack)) {
                        privateVars.trackedUrls.set(url, true);
                        container.trackPageView($.extend(true, {}, {
                            pageName: url.replace(/^(https?:\/\/)/, ''),
                            contenttitle: metaTitle.toLowerCase().replace(/"/g, "'")
                        }, (options.trackAdd || {})));
                    }


                } else {
                    container.msg(privateVars.name + ' disabled router to: ' + url);
                }
            },
            
            disable: function () {
                privateVars.disabled = true;
            },
            enable: function () {
                privateVars.disabled = false;
            }

        };


        var publicObj = {
            init: function (options) {
                privateMethods.prepareObj(options);
            },
            route: function (url, meta, options) {
                privateMethods.route(url, meta, options);
            },
            disable: function () {
                privateMethods.disable();
            },
            enable: function () {
                privateMethods.enable();
            }
        }

        return publicObj;
    }();

    return router;

});

/*
 ---
 var router = routerFactory.create();
 ---
 router.route('route');
 ---
 */